module.exports = __webpack_public_path__ + "img/banner.70538373.png";